
"use client";
import { NextProvider } from "@/Provider/HeroUIprovider";
import "./globals.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastProvider } from "@heroui/react";
import { useState } from "react";

export default function RootLayout({ children }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <html lang="en">
  <head><link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
        rel="stylesheet"
      /></head>
      

    <body className="antialiased" style={{ fontFamily: "Roboto, sans-serif" }}>
      <NextProvider>
        <QueryClientProvider client={queryClient}>
          <ToastProvider />
          {children}
        </QueryClientProvider>
      </NextProvider>
    </body>
  </html>

  );
}
